import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { WebStorageService, Scope } from '@mmortgage/common-utility';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'view-audit-details',
  templateUrl: './viewAuditDetails.component.html',
  styleUrls: ['./viewAuditDetails.component.less'],
  providers: [FrameworkUtilityComponent]
})
export class ViewAuditDetailsComponent implements OnInit {
  applicationId: any;
  currentRoutePath: string;
  auditIdDetails: any[] = [];
  rJson: any;
  constructor(private router: Router, private util: UtilService, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });
  }
  ngOnInit(): void {
    this.applicationId = localStorage.getItem('applicationId')
    this.rJson = JSON.parse(localStorage.getItem('rJson'))
    this.auditIdDetails = [
      {
        integrationAuditId: "275590",
        requestType: "LCMS_NOTIFICATION",
        status: "S",
        createdOn: "11-11-2021 15:28:48",
      }, {
        integrationAuditId: "274507",
        requestType: "LCMS_NOTIFICATION",
        status: "S",
        createdOn: "10-11-2021 17:51:32",
      },
      {
        integrationAuditId: "272098",
        requestType: "Full Application",
        status: "S",
        createdOn: "05-11-2021 21:42:33",
      }
    ]
  }
  viewRequest(auditID: any) {
    this.util.getAuditRequest(this.applicationId, auditID).subscribe((event) => {
      // alert(event)
      let viewJson = event;
      localStorage.setItem('viewType', "Request");
      localStorage.setItem('viewJson', JSON.stringify(viewJson));
      this.router.navigate(['../audit-view'], { relativeTo: this.activatedRoute });
    });
  }
  gotoAuditPage() {
    this.router.navigate(['../integration-audit'], { relativeTo: this.activatedRoute });
  }
  viewResponse(auditID: any) {
    this.util.getAuditResponse(this.applicationId, auditID).subscribe((event) => {
      let viewJson = event;
      localStorage.setItem('viewType', "Response");
      localStorage.setItem('viewJson', JSON.stringify(viewJson));
      this.router.navigate(['../audit-view'], { relativeTo: this.activatedRoute });
    });
  }
}